import script from "./sbcpInpInqNdPolOtpt.vue?vue&type=script&setup=true&lang=js"
export * from "./sbcpInpInqNdPolOtpt.vue?vue&type=script&setup=true&lang=js"

import "./sbcpInpInqNdPolOtpt.vue?vue&type=style&index=0&id=22a81e40&lang=css"

const __exports__ = script;

export default __exports__